/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query MccReadSmsQuery($endDate: DateTime!, $startDate: DateTime!) {
  MccReadSms(endDate: $endDate, startDate: $startDate) {
    id,
    status,
    message,
    _report
  }
}
`
